(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  (function () {
    if (window.SupermenHistorie) return;
    window.SupermenHistorie = true;
    document.addEventListener('click', function (e) {
      var knap = e.target.closest && e.target.closest('[data-sbp-kopier]');
      if (!knap) return;
      var url = knap.getAttribute('data-sbp-kopier');
      var tekst = knap.querySelector('[data-sbp-kopier-tekst]');
      var besked = knap.parentNode.querySelector('[data-sbp-besked]');
      function ok() {
        tekst.textContent = 'Kopieret';
        if (besked) besked.textContent = 'Linket er kopieret';
        clearTimeout(knap._t);
        knap._t = setTimeout(function () { tekst.textContent = 'Kopiér link'; if (besked) besked.textContent = ''; }, 2200);
      }
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(url).then(ok, function () { window.prompt('Kopiér linket', url); });
      else window.prompt('Kopiér linket', url);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.SupermenKurv) return;
    window.SupermenKurv = true;
    var R = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function post(sti, data) {
      return fetch(R + sti, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(data)
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Kurven kunne ikke opdateres. Prøv igen.');
          return j;
        });
      });
    }
    function money(c) {
      return ((+c || 0) / 100).toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr';
    }
    function sig(root, tekst) {
      var s = root.querySelector('[data-spk-status]');
      if (!s) return;
      s.textContent = '';
      window.setTimeout(function () { s.textContent = tekst; }, 60);
    }
    // Andre dele af siden (antal i headeren, Horizons kurv, gaveindpakning) får besked om den nye kurv
    function annoncer(root, cart) {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: root.dataset.section, data: { source: 'supermen-kurv', itemCount: cart.item_count } } }));
    }

    // Ny udgave af sektionen fra Shopify: åbne fold-ud, skrevet tekst, fokus og fragtmåler bevares
    function tegn(root, html) {
      if (!html) return;
      var ny = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-spk]');
      if (!ny) return;
      var aabne = {}, vaerdier = {}, fokus = null, a = document.activeElement;
      root.querySelectorAll('details[data-spk-fold]').forEach(function (d) { aabne[d.dataset.spkFold] = d.open; });
      root.querySelectorAll('[data-spk-bevar]').forEach(function (f) { vaerdier[f.dataset.spkBevar] = f.value; });
      if (a && root.contains(a)) fokus = a.getAttribute('data-spk-fokus') || (a.closest('[data-spk-linje]') ? 'linje' : null);
      var maaler = root.querySelector('[data-spk-maaler]');
      var foer = maaler ? maaler.style.transform : null;
      root.className = ny.className;
      root.innerHTML = ny.innerHTML;
      root.querySelectorAll('details[data-spk-fold]').forEach(function (d) { if (d.dataset.spkFold in aabne) d.open = aabne[d.dataset.spkFold]; });
      root.querySelectorAll('[data-spk-bevar]').forEach(function (f) { if (f.dataset.spkBevar in vaerdier) f.value = vaerdier[f.dataset.spkBevar]; });
      var m2 = root.querySelector('[data-spk-maaler]');
      if (m2 && foer !== null && foer !== m2.style.transform) {
        var mod = m2.style.transform;
        m2.style.transition = 'none';
        m2.style.transform = foer;
        void m2.offsetWidth;
        m2.style.transition = '';
        m2.style.transform = mod;
      }
      if (fokus) {
        var f2 = root.querySelector('[data-spk-fokus="' + fokus + '"]') || root.querySelector('[data-spk-titel]');
        if (f2) f2.focus({ preventScroll: true });
      }
      start(root);
    }

    // Alt gemmes ét ad gangen, så hurtige klik ikke overhaler hinanden
    function koe(root, job) {
      root._koe = (root._koe || Promise.resolve()).then(function () {
        root.classList.add('is-arbejder');
        return job();
      }).catch(function () {}).then(function () { root.classList.remove('is-arbejder'); });
      return root._koe;
    }
    function opdater(root) {
      var id = root.dataset.section;
      return fetch(R + 'cart?sections=' + encodeURIComponent(id), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) { tegn(root, j[id]); });
    }

    // Antal skifter med det samme; kurven gemmes bagefter. Flere hurtige klik samles til ét kald.
    function linjeFor(root, key) {
      var fundet = null;
      root.querySelectorAll('[data-spk-linje]').forEach(function (l) { if (l.dataset.key === key) fundet = l; });
      return fundet;
    }
    function antal(root, knap) {
      var linje = knap.closest('[data-spk-linje]');
      if (!linje) return;
      var key = linje.dataset.key, id = root.dataset.section;
      var trin = +linje.dataset.trin || 1, max = +linje.dataset.max || Infinity;
      root._maal = root._maal || {};
      root._sendt = root._sendt || {};
      var nu = key in root._maal ? root._maal[key] : key in root._sendt ? root._sendt[key] : +linje.dataset.antal;
      var r = +knap.dataset.spkAntal;
      var maal = r === 0 ? 0 : Math.min(max, Math.max(trin, nu + r * trin));
      if (maal === nu) return;
      root._maal[key] = maal;
      var fejl = linje.querySelector('[data-spk-fejl]');
      if (fejl) fejl.hidden = true;
      if (maal === 0) {
        linje.classList.add('is-fjernes');
      } else {
        var tal = linje.querySelector('[data-spk-tal]');
        if (tal) tal.textContent = maal;
        var minus = linje.querySelector('[data-spk-antal="-1"]'), plus = linje.querySelector('[data-spk-antal="1"]');
        var af = document.activeElement;
        if (minus) minus.disabled = maal <= trin;
        if (plus) plus.disabled = maal + trin > max;
        if (af === minus && minus.disabled && plus) plus.focus();
        else if (af === plus && plus.disabled && minus) minus.focus();
        linje.classList.add('is-arbejder');
      }
      return koe(root, function () {
        if (!(key in root._maal)) return;
        var m = root._maal[key];
        delete root._maal[key];
        root._sendt[key] = m;
        return post('cart/change.js', { id: key, quantity: m, sections: [id], sections_url: window.location.pathname }).then(function (cart) {
          if (root._sendt[key] === m) delete root._sendt[key];
          // Flere klik på vej: kun det sidste svar tegnes
          if (Object.keys(root._maal).length) return;
          tegn(root, cart.sections && cart.sections[id]);
          annoncer(root, cart);
          sig(root, m === 0 ? 'Varen er fjernet. I alt ' + money(cart.total_price) + '.' : 'Antal er ændret til ' + m + '. I alt ' + money(cart.total_price) + '.');
        }).catch(function (e) {
          delete root._maal[key];
          delete root._sendt[key];
          return opdater(root).then(function () {
            var l2 = linjeFor(root, key), f2 = l2 && l2.querySelector('[data-spk-fejl]');
            if (f2) { f2.textContent = e.message; f2.hidden = false; }
            sig(root, e.message);
          });
        });
      });
    }

    function koder(root) {
      var k = [];
      root.querySelectorAll('[data-spk-kode]').forEach(function (li) { k.push(li.dataset.spkKode); });
      (root._koder || []).forEach(function (c) { if (k.indexOf(c) < 0) k.push(c); });
      return k;
    }
    function kodeFejl(root, tekst) {
      var f = root.querySelector('[data-spk-kode-fejl]');
      if (!f) return;
      f.textContent = tekst;
      f.hidden = !tekst;
    }
    function brugKode(root, form) {
      var felt = form.querySelector('input[name="discount"]');
      var kode = (felt.value || '').trim();
      if (!kode) { felt.focus(); return; }
      var id = root.dataset.section, eks = koder(root);
      if (eks.some(function (c) { return c.toLowerCase() === kode.toLowerCase(); })) { kodeFejl(root, 'Koden er allerede brugt.'); return; }
      kodeFejl(root, '');
      return koe(root, function () {
        return post('cart/update.js', { discount: eks.concat(kode).join(','), sections: [id] }).then(function (cart) {
          var svar = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === kode.toLowerCase(); })[0];
          if (!svar || svar.applicable === false) {
            // Koden fjernes igen, så den ikke hænger ved i kurven
            return post('cart/update.js', { discount: eks.join(','), sections: [id] }).then(function (c2) {
              tegn(root, c2.sections && c2.sections[id]);
              kodeFejl(root, 'Koden "' + kode + '" kan ikke bruges på det, der ligger i kurven.');
              var f = root.querySelector('[data-spk-kode-form] input');
              if (f) { f.value = kode; f.focus(); }
            });
          }
          root._koder = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
          tegn(root, cart.sections && cart.sections[id]);
          annoncer(root, cart);
          var felt2 = root.querySelector('[data-spk-kode-form] input');
          if (felt2) felt2.value = '';
          if (!root.querySelector('[data-spk-kode="' + svar.code.replace(/"/g, '\\"') + '"]')) kodeFejl(root, 'Koden giver rabat på fragten. Den trækkes ved betaling.');
          sig(root, 'Rabatkoden ' + svar.code + ' er brugt. I alt ' + money(cart.total_price) + '.');
        }).catch(function (e) { kodeFejl(root, e.message); });
      });
    }
    function fjernKode(root, knap) {
      var kode = knap.closest('[data-spk-kode]').dataset.spkKode, id = root.dataset.section;
      var rest = koder(root).filter(function (c) { return c !== kode; });
      return koe(root, function () {
        return post('cart/update.js', { discount: rest.join(','), sections: [id] }).then(function (cart) {
          root._koder = rest;
          tegn(root, cart.sections && cart.sections[id]);
          annoncer(root, cart);
          var felt = root.querySelector('[data-spk-kode-form] input');
          if (felt) felt.focus();
          sig(root, 'Rabatkoden er fjernet. I alt ' + money(cart.total_price) + '.');
        });
      });
    }

    function gemBesked(root, felt) {
      window.clearTimeout(felt._t);
      felt._t = window.setTimeout(function () {
        var status = root.querySelector('[data-spk-besked-status]');
        post('cart/update.js', { note: felt.value }).then(function () {
          if (!status) return;
          status.textContent = 'Gemt';
          status.classList.add('is-vist');
          window.clearTimeout(status._t);
          status._t = window.setTimeout(function () { status.classList.remove('is-vist'); }, 1800);
        }).catch(function () {});
      }, 500);
    }

    // Bjælken nederst på mobil vises, når betalingsknappen i oversigten er længere nede
    function start(root) {
      if (root._io) root._io.disconnect();
      var bar = root.querySelector('[data-spk-bar]'), knap = root.querySelector('[data-spk-kasse]');
      if (!bar || !knap || !('IntersectionObserver' in window)) return;
      // Bjælkens knap får samme farver som betalingsknappen
      var kasse = knap.closest('.spk-kasse');
      if (kasse) ['--spk-knap', '--spk-knap-tekst', '--spk-knap-hover'].forEach(function (v) {
        var x = kasse.style.getPropertyValue(v);
        if (x) bar.style.setProperty(v, x);
      });
      root._io = new IntersectionObserver(function (e) {
        var vis = !e[0].isIntersecting && e[0].boundingClientRect.top > 0;
        bar.classList.toggle('is-vist', vis);
        bar.setAttribute('aria-hidden', vis ? 'false' : 'true');
        var b = bar.querySelector('button');
        if (b) b.tabIndex = vis ? 0 : -1;
      });
      root._io.observe(knap);
    }

    document.addEventListener('click', function (e) {
      var root = e.target.closest && e.target.closest('[data-spk]');
      if (!root) return;
      var k = e.target.closest('[data-spk-antal]');
      if (k && !k.disabled) { e.preventDefault(); antal(root, k); return; }
      var f = e.target.closest('[data-spk-kode-fjern]');
      if (f) { e.preventDefault(); fjernKode(root, f); }
    });
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-spk-kode-form]');
      if (!form) return;
      e.preventDefault();
      brugKode(form.closest('[data-spk]'), form);
    });
    document.addEventListener('input', function (e) {
      if (!e.target.matches || !e.target.matches('[data-spk-note]')) return;
      gemBesked(e.target.closest('[data-spk]'), e.target);
    });
    // Ændringer fra andre steder (Horizons kurv, hurtigkøb under kurven): kurvsiden hentes igen
    document.addEventListener('cart:update', function (e) {
      var d = e.detail || {};
      document.querySelectorAll('[data-spk]').forEach(function (root) {
        if (d.sourceId === root.dataset.section) return;
        koe(root, function () { return opdater(root); });
      });
    });
    function init() { document.querySelectorAll('[data-spk]').forEach(start); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    if (window.SupermenListe) return;
    window.SupermenListe = true;
    var roligt = window.matchMedia('(prefers-reduced-motion: reduce)');

    function alle(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function sig(root, tekst) {
      var s = root.querySelector('[data-spl-status]');
      if (!s) return;
      s.textContent = '';
      window.setTimeout(function () { s.textContent = tekst; }, 80);
    }
    function hentDok(root, href) {
      var u = new URL(href, window.location.href);
      u.searchParams.set('section_id', root.dataset.section);
      return fetch(u.toString())
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
    }
    function kolonner(liste) {
      var k = window.getComputedStyle(liste).gridTemplateColumns.split(' ').filter(Boolean).length;
      return Math.max(1, Math.min(k || 2, 6));
    }
    // Pladsholdere i samme antal og højde som de varer, der kommer, så siden ikke hopper, når de er hentet
    function pladsholdere(liste, n) {
      var ud = [], sidste = liste.querySelector('.spl-item:last-child'), h = sidste ? sidste.getBoundingClientRect().height : 0;
      for (var i = 0; i < n; i++) {
        var li = document.createElement('li');
        li.className = 'spl-item spl-item--skel';
        if (h) li.style.minHeight = Math.round(h) + 'px';
        li.setAttribute('aria-hidden', 'true');
        li.innerHTML = '<span class="spl-skel"></span><span class="spl-skel-linje"></span><span class="spl-skel-linje"></span>';
        liste.appendChild(li);
        ud.push(li);
      }
      return ud;
    }
    function nyeKort(doc) {
      return alle(doc, '[data-spl-liste] > .spl-item').map(function (li, i) {
        var n = document.importNode(li, true);
        n.classList.add('is-ny');
        n.style.setProperty('--i', i % 8);
        return n;
      });
    }

    /* ---------- Vis flere ---------- */
    function naeste(root, knap, fokus) {
      if (root._henter || !knap) return;
      var liste = root.querySelector('[data-spl-liste]');
      if (!liste) return;
      root._henter = true;
      knap.setAttribute('aria-busy', 'true');
      knap.textContent = 'Henter varer';
      var skel = pladsholdere(liste, parseInt(knap.dataset.splAntal, 10) || kolonner(liste));
      hentDok(root, knap.href)
        .then(function (doc) {
          skel.forEach(function (s) { s.remove(); });
          var nye = nyeKort(doc);
          var frag = document.createDocumentFragment();
          nye.forEach(function (n) { frag.appendChild(n); });
          liste.appendChild(frag);
          var mere = root.querySelector('[data-spl-mere]'), nyMere = doc.querySelector('[data-spl-mere]');
          if (mere && nyMere) mere.replaceWith(document.importNode(nyMere, true));
          else if (mere) mere.remove();
          if (window.SupermenKortKlar) window.SupermenKortKlar(root);
          var t = root.querySelector('.spl-mere__tekst');
          sig(root, nye.length + ' varer mere. ' + (t ? t.textContent.trim() + '.' : ''));
          if (fokus && nye[0]) {
            var l = nye[0].querySelector('.spd-kort__meta, a[href]');
            if (l) l.focus({ preventScroll: true });
          }
          root._henter = false;
          vagt(root);
        })
        .catch(function () {
          root._henter = false;
          window.location.assign(knap.href);
        });
    }

    /* ---------- De forrige varer (når man kommer tilbage til side 2 eller længere) ---------- */
    function forrige(root, link) {
      if (root._henter) return;
      var liste = root.querySelector('[data-spl-liste]');
      if (!liste) return;
      root._henter = true;
      link.setAttribute('aria-busy', 'true');
      link.textContent = 'Henter varer';
      hentDok(root, link.href)
        .then(function (doc) {
          var forste = liste.firstElementChild;
          var foer = forste ? forste.getBoundingClientRect().top : 0;
          var nye = nyeKort(doc);
          var frag = document.createDocumentFragment();
          nye.forEach(function (n) { n.classList.remove('is-ny'); frag.appendChild(n); });
          liste.insertBefore(frag, liste.firstChild);
          var boks = root.querySelector('[data-spl-forrige-boks]'), nyBoks = doc.querySelector('[data-spl-forrige-boks]');
          if (boks && nyBoks) boks.replaceWith(document.importNode(nyBoks, true));
          else if (boks) boks.remove();
          if (forste) window.scrollBy({ top: forste.getBoundingClientRect().top - foer, behavior: 'instant' });
          if (window.SupermenKortKlar) window.SupermenKortKlar(root);
          sig(root, nye.length + ' tidligere varer vises over de andre.');
          root._henter = false;
        })
        .catch(function () {
          root._henter = false;
          window.location.assign(link.href);
        });
    }

    /* ---------- Hent selv, når man nærmer sig bunden ---------- */
    function vagt(root) {
      if (root._io) { root._io.disconnect(); root._io = null; }
      if (!root.hasAttribute('data-spl-uendelig') || !('IntersectionObserver' in window)) return;
      var knap = root.querySelector('[data-spl-naeste]');
      if (!knap) return;
      root._io = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) naeste(root, knap, false);
      }, { rootMargin: '0px 0px 1600px 0px' });
      root._io.observe(knap);
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;
      var root = t.closest('[data-spl]');
      if (!root) return;
      var k = t.closest('[data-spl-naeste]');
      if (k) { e.preventDefault(); naeste(root, k, true); return; }
      var f = t.closest('[data-spl-forrige]');
      if (f) { e.preventDefault(); forrige(root, f); return; }
      // Husk siden og kortet, så "tilbage" fra en vare lander samme sted.
      // Kortet gemmes i browserens historik (ikke i adressen), så adressen forbliver pæn at dele.
      var a = t.closest('.spl-item a[href]');
      if (a) {
        var li = a.closest('.spl-item'), u = new URL(window.location.href), p = parseInt(li.dataset.page, 10) || 1;
        if (p > 1) u.searchParams.set('page', p); else u.searchParams.delete('page');
        u.hash = '';
        var st = Object.assign({}, window.history.state || {}, { splKort: li.id });
        try { window.history.replaceState(st, '', u.toString()); } catch (err) {}
      }
    });

    // Efter et nyt filter: hold øje med den nye knap, og gå op til varerne, hvis man er rullet forbi dem
    document.addEventListener('supermen:filtre', function (e) {
      var root = e.target.querySelector && e.target.querySelector('[data-spl]');
      if (!root) return;
      vagt(root);
      var lay = root.querySelector('.spl-layout');
      var top = lay ? lay.getBoundingClientRect().top : 0;
      if (top < 0) {
        var hoved = parseFloat(window.getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
        window.scrollTo({ top: window.scrollY + top - hoved, behavior: roligt.matches ? 'auto' : 'smooth' });
      }
    });

    function init() {
      alle(document, '[data-spl]').forEach(vagt);
      var st = window.history.state, id = st && st.splKort;
      // Ældre links med #kort i adressen virker stadig, men adressen ryddes
      if (!id && /^#template--/.test(window.location.hash)) {
        id = window.location.hash.slice(1);
        try { window.history.replaceState(Object.assign({}, st || {}, { splKort: id }), '', window.location.pathname + window.location.search); } catch (err) {}
      }
      if (id) {
        var kort = document.getElementById(id);
        if (kort && kort.classList.contains('spl-item')) kort.scrollIntoView({ behavior: 'instant', block: 'start' });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', function () { alle(document, '[data-spl]').forEach(vagt); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.SupermenProduktliste) return;
    window.SupermenProduktliste = true;
    var roligt = window.matchMedia('(prefers-reduced-motion: reduce)');

    function maal(root) {
      var spor = root.querySelector('[data-pl-spor]'), nav = root.querySelector('[data-pl-nav]'), maaler = root.querySelector('[data-pl-maaler]');
      if (!spor) return;
      var ruller = window.getComputedStyle(spor).display === 'flex' && spor.scrollWidth > spor.clientWidth + 2;
      if (nav) nav.hidden = !ruller;
      if (maaler) maaler.hidden = !ruller;
      if (!ruller) return;
      var max = spor.scrollWidth - spor.clientWidth;
      var x = Math.max(0, Math.min(spor.scrollLeft, max));
      if (nav) {
        nav.querySelector('[data-pl-dir="-1"]').disabled = x <= 2;
        nav.querySelector('[data-pl-dir="1"]').disabled = x >= max - 2;
      }
      if (maaler) {
        var s = spor.clientWidth / spor.scrollWidth;
        var tommel = maaler.querySelector('[data-pl-tommel]');
        tommel.style.setProperty('--pl-s', s.toFixed(4));
        tommel.style.setProperty('--pl-x', ((x / max) * (1 - s) * 100).toFixed(2) + '%');
      }
    }
    function skridt(spor) {
      var el = spor.firstElementChild;
      if (!el) return spor.clientWidth;
      var gap = parseFloat(window.getComputedStyle(spor).columnGap) || 0;
      var w = el.getBoundingClientRect().width + gap;
      return Math.max(1, Math.floor((spor.clientWidth + gap) / w)) * w;
    }
    function init(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('.spl-liste'), function (root) {
        if (root._pl) { maal(root); return; }
        root._pl = true;
        var spor = root.querySelector('[data-pl-spor]');
        if (!spor) return;
        var t = 0;
        spor.addEventListener('scroll', function () {
          if (t) return;
          t = window.requestAnimationFrame(function () { t = 0; maal(root); });
        }, { passive: true });
        if ('ResizeObserver' in window) new window.ResizeObserver(function () { maal(root); }).observe(spor);
        maal(root);
      });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-pl-dir]');
      if (!b) return;
      var root = b.closest('.spl-liste'), spor = root && root.querySelector('[data-pl-spor]');
      if (!spor) return;
      spor.scrollBy({ left: skridt(spor) * parseInt(b.dataset.plDir, 10), behavior: roligt.matches ? 'auto' : 'smooth' });
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supermen-kollektion-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.SupermenOenskeliste) return;
    window.SupermenOenskeliste = true;
    // Ønskelisten gemmes i kundens browser (samme nøgle som før). En ønskeliste-app kan lytte på supermen:wishlist.
    var NOEGLE = 'supermen-wishlist';
    function laes() { try { return JSON.parse(window.localStorage.getItem(NOEGLE)) || []; } catch (e) { return []; } }
    function gem(l) { try { window.localStorage.setItem(NOEGLE, JSON.stringify(l)); } catch (e) {} }
    function vis(scope) {
      var l = laes();
      Array.prototype.forEach.call((scope || document).querySelectorAll('.skh-hjerte[data-wishlist]'), function (b) {
        b.setAttribute('aria-pressed', l.indexOf(b.dataset.wishlist) > -1 ? 'true' : 'false');
      });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.skh-hjerte[data-wishlist]');
      if (!b) return;
      e.preventDefault();
      var h = b.dataset.wishlist, l = laes(), i = l.indexOf(h), til = i === -1;
      if (til) l.push(h); else l.splice(i, 1);
      gem(l);
      Array.prototype.forEach.call(document.querySelectorAll('.skh-hjerte[data-wishlist]'), function (x) {
        if (x.dataset.wishlist === h) x.setAttribute('aria-pressed', til ? 'true' : 'false');
      });
      document.dispatchEvent(new CustomEvent('supermen:wishlist', { detail: { handle: h, productId: b.dataset.productId, active: til, list: l } }));
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { vis(); }); else vis();
    document.addEventListener('shopify:section:load', function (e) { vis(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supermen-nyheder-bestsellere"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.SupermenFaner) return;
    window.SupermenFaner = true;

    function vaelg(fane, fokus) {
      var root = fane.closest('[data-snb]');
      var faner = root.querySelectorAll('[role="tab"]');
      Array.prototype.forEach.call(faner, function (f) {
        var valgt = f === fane;
        f.setAttribute('aria-selected', valgt ? 'true' : 'false');
        f.tabIndex = valgt ? 0 : -1;
        var p = document.getElementById(f.getAttribute('aria-controls'));
        if (!p) return;
        p.hidden = !valgt;
        p.classList.toggle('is-ny', valgt);
      });
      var alle = root.querySelector('[data-snb-alle]');
      if (alle && fane.dataset.url) alle.href = fane.dataset.url;
      if (fokus) fane.focus();
      fane.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (window.SupermenKortKlar) window.SupermenKortKlar(document.getElementById(fane.getAttribute('aria-controls')));
    }

    document.addEventListener('click', function (e) {
      var f = e.target.closest && e.target.closest('[data-snb] [role="tab"]');
      if (f) vaelg(f, false);
    });
    // Piletasterne flytter mellem fanerne (som i en almindelig fanebjælke)
    document.addEventListener('keydown', function (e) {
      var f = e.target.closest && e.target.closest('[data-snb] [role="tab"]');
      if (!f) return;
      var alle = Array.prototype.slice.call(f.parentNode.querySelectorAll('[role="tab"]'));
      var i = alle.indexOf(f), n = -1;
      if (e.key === 'ArrowRight') n = (i + 1) % alle.length;
      else if (e.key === 'ArrowLeft') n = (i - 1 + alle.length) % alle.length;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = alle.length - 1;
      if (n < 0) return;
      e.preventDefault();
      vaelg(alle[n], true);
    });
    // I temaeditoren vises fanen, man klikker på i sidepanelet
    document.addEventListener('shopify:block:select', function (e) {
      var f = e.target && e.target.matches && e.target.matches('[data-snb] [role="tab"]') ? e.target : null;
      if (f) vaelg(f, false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supermen-om-brandet"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.SupermenOmBrandet) return;
    window.SupermenOmBrandet = true;

    // "Læs mere" vises kun, når teksten er længere end de første linjer
    // Bunden af de første hele tekstlinjer, så klippet aldrig lander i luften mellem to afsnit
    function linjeBund(tekst, antal, lh) {
      var r = document.createRange(), top = tekst.getBoundingClientRect().top, bunde = [], node;
      var gaa = document.createTreeWalker(tekst, NodeFilter.SHOW_TEXT);
      while ((node = gaa.nextNode())) {
        if (!node.nodeValue.trim()) continue;
        r.selectNodeContents(node);
        Array.prototype.forEach.call(r.getClientRects(), function (b) {
          if (b.height < 4 || b.width < 1) return;
          var y = Math.round(b.bottom - top + Math.max(0, lh - b.height) / 2), sidste = bunde[bunde.length - 1];
          if (sidste === undefined || y > sidste + lh / 2) bunde.push(y);
          else if (y > sidste) bunde[bunde.length - 1] = y;
        });
        if (bunde.length > antal) break;
      }
      return bunde.length > antal ? bunde[antal - 1] : 0;
    }
    function maal(root) {
      var krop = root.querySelector('[data-sob-krop]');
      if (!krop) return;
      var tekst = krop.querySelector('[data-sob-tekst]'), knap = krop.querySelector('[data-sob-mere]');
      var aaben = krop.classList.contains('is-aaben');
      krop.classList.remove('is-aaben', 'is-lang');
      var lh = parseFloat(getComputedStyle(tekst).lineHeight) || 27;
      var antal = parseInt(getComputedStyle(root).getPropertyValue('--sob-linjer'), 10) || 3;
      // "Læs mere" kun, når der gemmer sig mindst én linje mere
      var bund = linjeBund(tekst, antal, lh);
      if (bund) krop.style.setProperty('--sob-luk', bund + 'px');
      krop.classList.toggle('is-lang', !!bund);
      krop.classList.toggle('is-aaben', aaben && !!bund);
      krop.style.setProperty('--sob-fuld', tekst.scrollHeight + 'px');
      knap.hidden = !bund;
    }
    function init(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-sob]'), function (root) {
        maal(root);
        if (root._sob) return;
        root._sob = true;
        if ('ResizeObserver' in window) {
          var w = root.clientWidth;
          new window.ResizeObserver(function () { if (root.clientWidth !== w) { w = root.clientWidth; maal(root); } }).observe(root);
        }
      });
    }
    document.addEventListener('click', function (e) {
      var knap = e.target.closest && e.target.closest('[data-sob-mere]');
      if (!knap) return;
      var krop = knap.closest('[data-sob-krop]'), tekst = krop.querySelector('[data-sob-tekst]');
      krop.style.setProperty('--sob-fuld', tekst.scrollHeight + 'px');
      var aaben = !krop.classList.contains('is-aaben');
      krop.classList.toggle('is-aaben', aaben);
      knap.setAttribute('aria-expanded', aaben ? 'true' : 'false');
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supermen-tak"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.SupermenTak) return;
    window.SupermenTak = true;
    function kopier(tekst) {
      if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(tekst);
      return new Promise(function (ok, nej) {
        var t = document.createElement('textarea');
        t.value = tekst; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
        document.body.appendChild(t); t.select();
        try { document.execCommand('copy') ? ok() : nej(); } catch (e) { nej(e); }
        t.remove();
      });
    }
    document.addEventListener('click', function (e) {
      var knap = e.target.closest('[data-stk-kopier]');
      if (!knap) return;
      var felt = knap.closest('.stk__felt');
      var kode = felt.querySelector('[data-stk-kode]').textContent.trim();
      var tekst = knap.querySelector('[data-stk-kopier-tekst]');
      var besked = felt.querySelector('[data-stk-besked]');
      kopier(kode).then(function () {
        knap.classList.add('is-kopieret');
        tekst.textContent = 'Kopieret';
        besked.textContent = 'Rabatkoden ' + kode + ' er kopieret';
        clearTimeout(knap._t);
        knap._t = setTimeout(function () { knap.classList.remove('is-kopieret'); tekst.textContent = 'Kopiér'; besked.textContent = ''; }, 2400);
      }, function () {
        var r = document.createRange(); r.selectNodeContents(felt.querySelector('[data-stk-kode]'));
        var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
        besked.textContent = 'Koden er markeret. Kopiér den med Ctrl+C';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supermen-vare"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.SupermenVare) return;
    var S = (window.SupermenVare = {});

    function money(cents) {
      return (cents / 100).toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr';
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function base(root) { return ((root && root.dataset.root) || '/').replace(/\/?$/, '/'); }
    S.money = money;
    // Samme tekst som blokken Pris: kr uden øre og hele procent, rundet ned
    function sparTekst(ore, foer) {
      return { pct: '−' + Math.floor(ore * 100 / foer) + '%', kr: 'Spar ' + money(ore).replace(',00 kr', ' kr') };
    }

    /* ---------- Billeder: kantfarve og foto/packshot ---------- */
    // Et billede med ensfarvet kant er et packshot: felterne om billedet får kantens farve.
    // Et billede med motiv helt ud til kanten er et foto: det fylder hele rammen.
    var edgeCache = {};
    function edgeInfo(url) {
      if (!url) return Promise.resolve(null);
      if (url.indexOf('//') === 0) url = window.location.protocol + url;
      if (edgeCache[url]) return edgeCache[url];
      edgeCache[url] = new Promise(function (resolve) {
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload = function () {
          try {
            var w = im.naturalWidth, h = im.naturalHeight;
            var c = document.createElement('canvas');
            c.width = w; c.height = h;
            var x = c.getContext('2d');
            x.drawImage(im, 0, 0);
            var d = x.getImageData(0, 0, w, h).data;
            var top = [0, 0, 0, 0], bot = [0, 0, 0, 0], lum = [], topL = [], botL = [];
            function l(i) { return 0.299 * d[i * 4] + 0.587 * d[i * 4 + 1] + 0.114 * d[i * 4 + 2]; }
            for (var i = 0; i < w; i++) {
              lum.push(l(i), l((h - 1) * w + i));
              topL.push(l(i));
              botL.push(l((h - 1) * w + i));
              if (i >= Math.floor(w / 4) && i < Math.ceil((w * 3) / 4)) {
                for (var k = 0; k < 3; k++) { top[k] += d[i * 4 + k]; bot[k] += d[((h - 1) * w + i) * 4 + k]; }
                top[3]++; bot[3]++;
              }
            }
            var side = [0, 0, 0, 0], sideL = [];
            for (var j = 1; j < h - 1; j++) {
              lum.push(l(j * w), l(j * w + w - 1));
              sideL.push(l(j * w), l(j * w + w - 1));
              for (var q = 0; q < 3; q++) side[q] += d[j * w * 4 + q] + d[(j * w + w - 1) * 4 + q];
              side[3] += 2;
            }
            function spread(arr) {
              var mm = arr.reduce(function (a, v) { return a + v; }, 0) / arr.length;
              return Math.sqrt(arr.reduce(function (a, v) { return a + (v - mm) * (v - mm); }, 0) / arr.length);
            }
            var sd = spread(lum);
            // Kun top og sider (benene på en model går tit ud over bunden af et studiebillede)
            var upper = [];
            for (var t = 0; t < w; t++) upper.push(l(t));
            for (var u = 1; u < Math.round(h * 0.7); u++) upper.push(l(u * w), l(u * w + w - 1));
            var sdTop = spread(upper);
            function rgb(a) { return 'rgb(' + Math.round(a[0] / a[3]) + ',' + Math.round(a[1] / a[3]) + ',' + Math.round(a[2] / a[3]) + ')'; }
            // En kant, hvor varen går helt ud (f.eks. sokker i bunden), giver ikke en brugbar farve:
            // så bruges den rolige kants farve begge steder
            var cols = [rgb(top), rgb(bot)], sT = spread(topL), sB = spread(botL);
            if (sB > 10 && sT <= 10) cols[1] = cols[0];
            else if (sT > 10 && sB <= 10) cols[0] = cols[1];
            else if (sT > 10 && sB > 10) cols = spread(sideL) <= 10 ? [rgb(side), rgb(side)] : null;
            // Hvid bund: billedet kan lægges ind på den lysegrå flade (mix-blend-mode: multiply)
            var light = !!cols && cols.every(function (c) {
              var v = c.match(/\d+/g).map(Number);
              return 0.299 * v[0] + 0.587 * v[1] + 0.114 * v[2] >= 244;
            });
            // Rolig kant = ingen spring mellem nabopunkter (en blød skygge eller vignet er rolig, en vare der går ud over kanten er ikke)
            function step(arr) { var m = 0; for (var s = 1; s < arr.length; s++) m = Math.max(m, Math.abs(arr[s] - arr[s - 1])); return m; }
            function mean(arr) { return arr.reduce(function (a, v) { return a + v; }, 0) / arr.length; }
            // Kant: rolig (spring op til 8), blød (op til 30, f.eks. vignet) eller uro (en vare går ud over kanten)
            var rolig = [topL, botL].filter(function (r) { return step(r) <= 8; });
            var blod = [topL, botL].filter(function (r) { var st = step(r); return st > 8 && st <= 30; });
            var calm = [].concat.apply([], rolig);
            // Næsten hvid, flad bund: lægges på den lysegrå flade, og lysnes lidt, så bunden rammer fladen præcist
            var hvid = !blod.length && calm.length > 0 && Math.min.apply(null, calm) >= 244 && mean(calm) >= 245;
            var lys = hvid ? Math.min(1.04, 255 / mean(calm)) : light ? Math.min(1.04, 255 / mean(topL.concat(botL))) : 1;
            var full = [[0, 0, 0], [0, 0, 0]];
            for (var f = 0; f < w; f++) for (var g = 0; g < 3; g++) { full[0][g] += d[f * 4 + g]; full[1][g] += d[((h - 1) * w + f) * 4 + g]; }
            var flad = full.map(function (a) { return 'rgb(' + a.map(function (v) { return Math.round(v / w); }).join(',') + ')'; });
            // Kantens farveforløb fra venstre mod højre, udjævnet (3 punkter), som en CSS-gradient
            function forloeb(y) {
              var wt = [1, 2, 1], stops = [];
              for (var i = 0; i < w; i++) {
                var acc = [0, 0, 0], n = 0;
                for (var k = -1; k <= 1; k++) {
                  var xi = Math.min(w - 1, Math.max(0, i + k)), o = (y * w + xi) * 4;
                  for (var c = 0; c < 3; c++) acc[c] += d[o + c] * wt[k + 1];
                  n += wt[k + 1];
                }
                stops.push('rgb(' + acc.map(function (v) { return Math.round(v / n); }).join(',') + ') ' + (((i + 0.5) / w) * 100).toFixed(1) + '%');
              }
              return 'linear-gradient(to right, ' + stops.join(', ') + ')';
            }
            resolve({ photo: sd > 16, light: light, hvid: hvid, lys: lys.toFixed(3), sdTop: sdTop, ratio: w / h, cols: cols, blodT: step(topL) <= 30, blodB: step(botL) <= 30, flad: flad, gradT: forloeb(0), gradB: forloeb(h - 1) });
          } catch (e) { resolve(null); }
        };
        im.onerror = function () { resolve(null); };
        im.src = url;
      });
      return edgeCache[url];
    }
    function sampleBg(el) {
      var url = el.getAttribute('data-bg');
      if (!url || el.dataset.bgDone) return;
      el.dataset.bgDone = '1';
      edgeInfo(url).then(function (info) {
        if (!info) return;
        if (info.photo && info.ratio <= 1.2) { el.classList.add('is-photo'); return; }
        var sq = el.classList.contains('is-square');
        if (info.hvid || (!sq && !info.photo && info.light)) {
          el.style.setProperty('--spd-lys', info.lys);
          el.classList.add('is-hvid');
          return;
        }
        if (!sq) return;
        // Bredt billede i en høj ramme: felterne over og under fortsætter billedets egen kant,
        // så grå bund, skygge og vignet går helt ud (kantens farveforløb fra venstre mod højre)
        if ((info.blodT || info.blodB) && !el.classList.contains('spd-farver__im')) {
          el.style.setProperty('--spd-kant-top', info.blodT ? info.gradT : info.flad[1]);
          el.style.setProperty('--spd-kant-bund', info.blodB ? info.gradB : info.flad[0]);
          el.style.backgroundColor = info.flad[info.blodT ? 0 : 1];
          el.classList.add('is-kant');
          return;
        }
        if (!info.cols) return;
        el.style.backgroundColor = info.cols[0];
        el.style.backgroundImage = 'linear-gradient(' + info.cols[0] + ' 50%, ' + info.cols[1] + ' 50%)';
      });
    }
    S.sampleBg = sampleBg;
    S.edgeInfo = edgeInfo;

    // Farverne skal ligne hinanden: er de fleste studiebilleder, og et par stykker stemningsfotos,
    // skiftes de sidste til varens næste studiebillede (data-skift kommer fra snippets/supermen-billede).
    // Farveprik uden kendt farvenavn: gennemsnittet midt på billedet (der, hvor tøjet sidder)
    function prikGaet(el) {
      var url = el.dataset.spdPrik;
      if (!url) return;
      if (url.indexOf('//') === 0) url = window.location.protocol + url;
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var w = im.naturalWidth, h = im.naturalHeight, c = document.createElement('canvas');
          c.width = w; c.height = h;
          var x = c.getContext('2d');
          x.drawImage(im, 0, 0);
          var x0 = Math.floor(w * 0.4), x1 = Math.ceil(w * 0.6), y0 = Math.floor(h * 0.35), y1 = Math.ceil(h * 0.55);
          var d = x.getImageData(x0, y0, Math.max(1, x1 - x0), Math.max(1, y1 - y0)).data, r = 0, g = 0, b = 0, n = 0;
          for (var i = 0; i < d.length; i += 4) { r += d[i]; g += d[i + 1]; b += d[i + 2]; n++; }
          if (n) el.style.setProperty('--fp', 'rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')');
        } catch (e) {}
      };
      im.src = url;
    }
    function ensart(els) {
      els = els.filter(function (e) { return e.dataset.tiny; });
      if (els.length < 3) return;
      Promise.all(els.map(function (e) { return edgeInfo(e.dataset.tiny); })).then(function (infos) {
        var clean = 0, odd = [];
        infos.forEach(function (x, i) {
          if (!x) return;
          if (x.sdTop <= 8) clean++;
          else if (x.sdTop > 25) odd.push(els[i]);
        });
        if (!odd.length || clean < 2 || odd.length >= clean) return;
        odd.forEach(function (el) {
          var alts = el.dataset.skift.split('^').map(function (s) {
            var p = s.split('~');
            return { tiny: p[0], src: p[1], srcset: p[2], ratio: +p[3] || 0.8 };
          });
          (function next(k) {
            if (k >= alts.length) return;
            edgeInfo(alts[k].tiny).then(function (x) {
              if (!x || x.sdTop > 8) return next(k + 1);
              var a = alts[k], img = el.querySelector('img');
              if (!img) return;
              img.srcset = a.srcset;
              img.src = a.src;
              el.classList.remove('is-photo', 'is-square', 'is-hvid', 'is-kant');
              el.style.backgroundColor = '';
              el.style.backgroundImage = '';
              ['--spd-lys', '--spd-kant-top', '--spd-kant-bund'].forEach(function (v) { el.style.removeProperty(v); });
              delete el.dataset.bgDone;
              if (a.ratio > (+el.dataset.format || 0.8) + 0.12) el.classList.add('is-square');
              el.setAttribute('data-bg', a.tiny);
              sampleBg(el);
            });
          })(0);
        });
      });
    }

    /* ---------- Fælles: Escape, fokusfælde og tilføj fra andre sektioner ---------- */
    function main() {
      var r = document.querySelector('[data-spd-vare][data-ready]');
      return r && r._spd;
    }
    document.addEventListener('keydown', function (e) {
      var a = main();
      if (!a) return;
      if (e.key === 'Escape') { a.closeLys(); a.closeKurv(); }
      if (e.key === 'Tab') a.trap(e);
    });
    document.addEventListener('supermen:add', function (e) {
      var a = main();
      if (!a) return;
      a.addItems(e.detail.items).then(function () {
        if (e.detail.onSuccess) e.detail.onSuccess();
        return a.afterAdd();
      }).catch(function (err) { if (e.detail.onError) e.detail.onError(err.message); });
    });

    /* ---------- Supermen vare ---------- */
    function initVare(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var $ = function (s) { return root.querySelector(s); };
      var jsonEl = $('[data-spd-json]');
      var data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [], single: true };
      all(root, '[data-bg]').forEach(sampleBg);
      ensart(all(root, '.spd-farver__im'));
      all(root, '[data-spd-prik]').forEach(prikGaet);

      /* Galleri */
      var track = $('[data-spd-slides]');
      var slides = track ? Array.prototype.slice.call(track.children) : [];
      var thumbs = all(root, '[data-spd-thumb]');
      var bars = all(root, '.spd-galleri__forloeb i');
      var prev = $('[data-spd-prev]'), next = $('[data-spd-next]');
      var cur = 0;
      function setCur(i) {
        cur = i;
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        bars.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
      }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth });
      }
      if (track && slides.length > 1) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (es) {
            es.forEach(function (e) { if (e.isIntersecting) setCur(+e.target.dataset.i); });
          }, { root: track, threshold: 0.6 });
          slides.forEach(function (s) { io.observe(s); });
        }
        setCur(0);
        thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.spdThumb); }); });
        if (prev) prev.addEventListener('click', function () { go(cur - 1); });
        if (next) next.addEventListener('click', function () { go(cur + 1); });
        track.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
        });
      }

      /* Fuld størrelse: alle billeder under hinanden (kan zoomes med fingrene på mobil) */
      var lys = $('[data-spd-lys]');
      var lysReturn = null;
      var galleri = $('[data-spd-galleri]');
      if (track && galleri && galleri.classList.contains('spd-galleri--zoom')) {
        track.addEventListener('click', function (e) {
          var f = e.target.closest('[data-full]');
          if (!f) return;
          var inner = $('[data-spd-lys-indhold]');
          inner.innerHTML = '';
          slides.forEach(function (s) {
            if (!s.dataset.full) return;
            var im = document.createElement('img');
            im.src = s.dataset.full;
            im.alt = (s.querySelector('img') || {}).alt || '';
            im.loading = 'lazy';
            inner.appendChild(im);
          });
          lysReturn = document.activeElement;
          lys.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          var target = inner.children[+f.dataset.i];
          if (target) target.scrollIntoView();
          $('[data-spd-lys-luk]').focus();
        });
      }
      function closeLys() {
        if (!lys || lys.hidden) return;
        lys.hidden = true;
        document.documentElement.style.overflow = '';
        if (lysReturn && lysReturn.focus) lysReturn.focus();
      }
      if (lys) $('[data-spd-lys-luk]').addEventListener('click', closeLys);

      /* Farver: navnet skifter, når man peger på en farve */
      var farveNavn = $('[data-spd-farve-navn]');
      if (farveNavn) {
        all(root, '.spd-farver__en').forEach(function (a) {
          function set(t) { farveNavn.textContent = t ? ' ' + t : ''; }
          function show() { set(a.dataset.label); }
          function reset() { set(farveNavn.dataset.current); }
          a.addEventListener('mouseenter', show);
          a.addEventListener('focus', show);
          a.addEventListener('mouseleave', reset);
          a.addEventListener('blur', reset);
        });
      }
      var flere = $('[data-spd-farver-flere]');
      if (flere) {
        flere.addEventListener('click', function () {
          var liste = flere.closest('[data-spd-farver]');
          liste.classList.add('is-alle');
          flere.setAttribute('aria-expanded', 'true');
          var forste = liste.querySelector('.is-ekstra');
          if (forste) forste.focus();
        });
      }

      /* Størrelser og pris */
      var form = document.getElementById(root.dataset.formId);
      var input = $('[data-spd-variant-input]');
      var atc = $('[data-spd-atc]');
      var atcLabel = $('[data-spd-atc-label]');
      var note = $('[data-spd-note]');
      var stock = $('[data-spd-stock]');
      var priceEl = $('[data-spd-price]');
      var groups = all(root, '[data-spd-opt]');
      var variants = data.variants;
      var sel = [];
      var radios = all(root, '[data-spd-antal]');
      var stepper = $('[data-spd-stepper]');
      var qtyInput = $('[data-spd-qty]');
      var tilbud = $('[data-spd-tilbud]');
      // Med tilbud vælges antallet i tilbudsboksen, så antalsvælgeren skjules
      if (radios.length && stepper) { stepper.hidden = true; stepper.style.display = 'none'; if (qtyInput) qtyInput.removeAttribute('name'); qtyInput = null; }

      // En gruppe er enten felter (knapper med data-value) eller en rulleliste (f.eks. beløb på gavekort)
      function isList(g) { return g.tagName === 'SELECT'; }
      groups.forEach(function (g, i) {
        if (isList(g)) { sel[i] = g.value || null; return; }
        var pressed = g.querySelector('[aria-pressed="true"]');
        var only = g.querySelectorAll('[data-value]');
        sel[i] = pressed ? pressed.dataset.value : only.length === 1 ? only[0].dataset.value : null;
      });
      if ((data.single || !groups.length) && variants.length) sel = variants[0].options.slice();

      var allOut = !variants.some(function (v) { return v.available; });
      var priceMin = Math.min.apply(null, variants.map(function (v) { return v.price; }));
      var priceMax = Math.max.apply(null, variants.map(function (v) { return v.price; }));
      function current() {
        if (!variants.length || sel.some(function (v) { return v == null; })) return null;
        return variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); }) || null;
      }
      function matches(i, val, needStock) {
        return variants.some(function (v) {
          if ((needStock && !v.available) || v.options[i] !== val) return false;
          return v.options.every(function (o, k) { return k === i || sel[k] == null || o === sel[k]; });
        });
      }
      function qty() {
        var r = radios.filter(function (x) { return x.checked; })[0];
        if (r) return +r.value || 1;
        return qtyInput ? Math.min(20, Math.max(1, parseInt(qtyInput.value, 10) || 1)) : 1;
      }
      function missing() {
        return groups.filter(function (g, i) { return sel[i] == null; }).map(function (g) { return g.dataset.name || 'størrelse'; });
      }
      function bundleTotal(v) {
        if (!tilbud) return 0;
        var total = +tilbud.dataset.total || 0, pay = +tilbud.dataset.pay || 0;
        return total > 0 ? total : v.price * pay;
      }
      function render(fromUser) {
        groups.forEach(function (g, i) {
          if (isList(g)) {
            g.value = sel[i] == null ? '' : sel[i];
            all(g, 'option[value]').forEach(function (o) {
              if (!o.value) return;
              var ok = matches(i, o.value, true);
              o.textContent = (o.dataset.label || o.value) + (ok ? '' : ' (udsolgt)');
            });
            return;
          }
          all(g, '[data-value]').forEach(function (b) {
            var on = sel[i] === b.dataset.value;
            var ok = matches(i, b.dataset.value, true);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
            b.classList.toggle('is-udsolgt', !ok);
            var sr = b.querySelector('.spd-sr');
            if (!ok && !sr) { sr = document.createElement('span'); sr.className = 'spd-sr'; sr.textContent = ' (udsolgt)'; b.appendChild(sr); }
            if (ok && sr) sr.remove();
          });
        });
        var v = current();
        var ok = !!(v && v.available);
        var miss = missing();
        if (input && input.value !== String(v ? v.id : '')) {
          input.value = v ? v.id : '';
          // "Giv besked"-apps (f.eks. EcomSend) lytter efter den valgte variant
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var soldOut = allOut || (v && !v.available);
        if (atc) {
          atc.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
          atc.classList.toggle('is-vaelg', !v && !allOut);
        }
        if (atcLabel) atcLabel.textContent = ok ? atc.dataset.label : soldOut ? 'Udsolgt' : 'Vælg ' + (miss[0] || 'størrelse');
        if (note) {
          note.classList.remove('is-alert');
          note.textContent = miss.length && miss.length < groups.length ? 'Vælg også ' + miss.join(' og ') + '.' : v && !v.available && !allOut ? (groups.length > 1 ? 'Udsolgt i den kombination.' : 'Udsolgt i ' + sel[0] + '.') : '';
        }
        if (stock) {
          var faa = +stock.dataset.faa || 0;
          stock.innerHTML = ok ? (v.q != null && faa > 0 && v.q <= faa ? '<span class="spd-prik is-faa"></span>Få tilbage' : '<span class="spd-prik"></span>På lager') : '';
        }
        var shown = v || variants.filter(function (x) { return x.available; })[0] || variants[0];
        // Forskellige priser og intet valgt endnu (f.eks. gavekort): "Fra" laveste pris
        var fra = !v && priceMin < priceMax;
        if (shown) {
          var sale = !fra && shown.compare > shown.price;
          if (priceEl) {
            priceEl.textContent = fra ? 'Fra ' + money(priceMin) : money(shown.price);
            priceEl.classList.toggle('is-udsalg', sale);
          }
          var cmp = $('[data-spd-compare]');
          if (cmp) {
            cmp.hidden = !sale;
            $('[data-spd-compare-val]').textContent = money(shown.compare);
          }
          var spar = $('[data-spd-spar]');
          if (spar) {
            spar.hidden = !sale;
            if (sale) {
              var st = sparTekst(shown.compare - shown.price, shown.compare);
              var sp = spar.querySelector('[data-spd-spar-pct]'), sk = spar.querySelector('[data-spd-spar-kr]');
              if (sp) sp.textContent = st.pct;
              if (sk) sk.textContent = st.kr;
            }
          }
          if (tilbud) {
            var n = +tilbud.dataset.qty || 2;
            var bt = bundleTotal(shown);
            var save = shown.price * n - bt;
            var en = $('[data-spd-tilbud-en]'), alle = $('[data-spd-tilbud-alle]'), spar = $('[data-spd-tilbud-spar]');
            if (en) en.textContent = money(shown.price);
            if (alle) alle.textContent = money(bt);
            if (spar) { spar.hidden = save <= 0; $('[data-spd-tilbud-spar-kr]').textContent = money(save).replace(',00 kr', ' kr'); }
          }
        }
        if (v && fromUser && !data.single) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(window.history.state, '', url.toString());
        }
        var sub = $('[data-spd-mbar-sub]');
        if (sub && shown) {
          var q = qty();
          var price = tilbud && q > 1 && q === (+tilbud.dataset.qty) ? bundleTotal(shown) : shown.price * q;
          sub.textContent = (v && !data.single ? sel.join(' / ') + ' · ' : '') + (q > 1 ? q + ' stk. · ' : '') + (fra ? 'Fra ' + money(priceMin) : money(price));
        }
        var mb = $('[data-spd-mbar-btn]');
        if (mb) mb.textContent = ok ? (atc ? atc.dataset.label : 'Læg i kurv') : soldOut ? 'Udsolgt' : 'Vælg ' + (miss[0] || 'størrelse');
      }
      function afterPick(i) {
        groups.forEach(function (o, k) { if (k !== i && sel[k] != null && !matches(k, sel[k], false)) sel[k] = null; });
        render(true);
      }
      groups.forEach(function (g, i) {
        if (isList(g)) {
          g.addEventListener('change', function () { sel[i] = g.value || null; afterPick(i); });
          return;
        }
        g.addEventListener('click', function (e) {
          // Udsolgte størrelser kan også vælges, så kunden kan bede om besked, når de kommer igen
          var b = e.target.closest('[data-value]');
          if (!b) return;
          sel[i] = sel[i] === b.dataset.value && groups.length > 1 ? null : b.dataset.value;
          afterPick(i);
        });
      });
      radios.forEach(function (r) { r.addEventListener('change', function () { render(); }); });
      all(root, '[data-spd-step]').forEach(function (b) {
        b.addEventListener('click', function () { if (!qtyInput) return; qtyInput.value = Math.min(20, Math.max(1, qty() + +b.dataset.spdStep)); render(); });
      });
      if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = qty(); render(); });
      render(false);

      /* Kurv */
      var kurv = $('[data-spd-kurv]');
      var threshold = +root.dataset.threshold || 0;
      var kurvReturn = null;

      /* Gaveindpakning: samme felt på ordren som kurvsiden, én linje pr. vare og størrelse:
         "Varenavn - Farve - XL (x1), Varenavn - Farve - M (x2)" (Shopifys navn på linjen) */
      var gave = root.dataset.gaveKurv === 'true';
      var gaveNoegle = root.dataset.gaveNoegle || 'giftwrap';
      var gaveIkonEl = $('[data-spd-gave-ikon]');
      var gaveIkon = gaveIkonEl ? gaveIkonEl.innerHTML : '';
      var gaveSet = [], sidsteKurv = null, gaveKoe = Promise.resolve(), gaveVenter = 0;
      function hentKurv() {
        return fetch(base(root) + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      }
      function gaveNavn(it) { return it.title || it.product_title; }
      function gaveTitler(cart) {
        var v = String((cart.attributes || {})[gaveNoegle] || ''), t = [], m;
        var re = /\s*(.+?) \(x\d+\)\s*(?:,|$)/g;
        while ((m = re.exec(v))) if (t.indexOf(m[1]) < 0) t.push(m[1]);
        if (!t.length && v.trim()) v.split(',').forEach(function (d) { d = d.trim(); if (d && t.indexOf(d) < 0) t.push(d); });
        return t;
      }
      function gaveGem(cart, titler) {
        var tekst = cart.items.filter(function (it) { return titler.indexOf(gaveNavn(it)) > -1; })
          .map(function (it) { return gaveNavn(it) + ' (x' + it.quantity + ')'; }).join(', ');
        if (tekst === String((cart.attributes || {})[gaveNoegle] || '')) return Promise.resolve(cart);
        var a = {};
        a[gaveNoegle] = tekst;
        return fetch(base(root) + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: a })
        }).then(function (r) {
          if (!r.ok) throw new Error('Gaveindpakningen kunne ikke gemmes. Prøv igen.');
          return r.json();
        });
      }
      function lineHtml(it, i) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1?width=180&') : '';
        var opts = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
        // Samme navneregler som snippets/supermen-navn: uden brand, farven på linjen under
        var title = it.product_title || '';
        if (it.vendor && title.toLowerCase().indexOf(it.vendor.toLowerCase() + ' ') === 0) title = title.slice(it.vendor.length + 1).replace(/^[-–]\s*/, '');
        var farve = '';
        var fm = title.match(/^(.+?)\s+[-–\/]\s+(.+)$/) || title.match(/^(.*[a-zæøå].*?)\s+([A-ZÆØÅ0-9][A-ZÆØÅ0-9 ]*[A-ZÆØÅ])$/);
        if (fm && !(it.product_type && fm[2].toLowerCase().indexOf(it.product_type.toLowerCase()) > -1)) {
          title = fm[1];
          farve = fm[2];
          if (farve === farve.toUpperCase()) farve = farve.toLowerCase().replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); });
        }
        title = title.replace(/\s+[-–]\s+/g, ' ');
        if (/ /.test(opts) && opts === opts.toUpperCase() && /[A-ZÆØÅ]/.test(opts)) opts = opts.charAt(0) + opts.slice(1).toLowerCase();
        var n = i + 1;
        var gaveKnap = '';
        if (gave && !it.gift_card && !/gavekort/i.test(it.product_type || '')) {
          var paa = gaveSet.indexOf(gaveNavn(it)) > -1;
          gaveKnap = '<button type="button" class="spd-linje__gave" data-gave-titel="' + esc(gaveNavn(it)) + '" aria-pressed="' + paa + '">' + gaveIkon + '</button>';
        }
        return '<div class="spd-linje' + (gaveKnap ? ' har-gave' : '') + '">' +
          (img ? '<img src="' + esc(img) + '" alt="' + esc(title + (farve ? ' – ' + farve : '')) + '" loading="lazy">' : '<span></span>') +
          '<div><a href="' + esc(it.url) + '">' + esc(title) + '</a>' +
          '<small>' + esc([farve, opts].filter(Boolean).join(' · ')) + '</small>' +
          '<div class="spd-linje__antal"><div class="spd-antal"><button type="button" data-line="' + n + '" data-to="' + (it.quantity - 1) + '" aria-label="Færre">&minus;</button><span>' + it.quantity + '</span><button type="button" data-line="' + n + '" data-to="' + (it.quantity + 1) + '" aria-label="Flere">+</button></div>' +
          '<button type="button" class="spd-linje__fjern" data-line="' + n + '" data-to="0">Fjern</button></div></div>' +
          '<div class="spd-linje__pris">' + was + money(it.final_line_price) + '</div>' + gaveKnap + '</div>';
      }
      function paint(cart) {
        sidsteKurv = cart;
        gaveSet = gave ? gaveTitler(cart) : [];
        var left = threshold - cart.total_price;
        $('[data-spd-fragt]').innerHTML = threshold > 0 && cart.item_count
          ? (left > 0 ? 'Du mangler <b>' + money(left) + '</b> for fri fragt' : '<b>Du har fri fragt</b>') + '<div class="spd-maaler"><i style="transform:scaleX(' + Math.min(1, cart.total_price / threshold) + ')"></i></div>'
          : '';
        $('[data-spd-linjer]').innerHTML = cart.items.length ? cart.items.map(lineHtml).join('') : '<p class="spd-kurv__tom">Kurven er tom.</p>';
        var rabat = $('[data-spd-rabat]');
        rabat.hidden = !cart.total_discount;
        // Navnet på jeres automatiske rabat (f.eks. "2 for 500 kr"), når Shopify sender det med
        var names = [];
        (cart.cart_level_discount_applications || []).forEach(function (d) { if (d.title && names.indexOf(d.title) < 0) names.push(d.title); });
        cart.items.forEach(function (it) {
          (it.line_level_discount_allocations || []).forEach(function (a) {
            var t = a.discount_application && a.discount_application.title;
            if (t && names.indexOf(t) < 0) names.push(t);
          });
        });
        rabat.innerHTML = '<span>Rabat' + (names.length ? ', ' + esc(names.join(', ')) : '') + '</span><span>-' + money(cart.total_discount) + '</span>';
        $('[data-spd-total]').textContent = money(cart.total_price);
        $('[data-spd-kurv-antal]').textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
      }
      function openKurv(cart) {
        paint(cart);
        kurvReturn = document.activeElement;
        root.classList.add('is-kurv');
        kurv.setAttribute('aria-hidden', 'false');
        window.setTimeout(function () { $('[data-spd-kurv-luk]').focus(); }, 60);
      }
      function closeKurv() {
        if (!root.classList.contains('is-kurv')) return;
        root.classList.remove('is-kurv');
        kurv.setAttribute('aria-hidden', 'true');
        if (kurvReturn && kurvReturn.focus) kurvReturn.focus();
      }
      function trap(e) {
        if (!root.classList.contains('is-kurv')) return;
        var f = all(kurv, 'a[href], button:not([disabled])');
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
        else if (!kurv.contains(document.activeElement)) { e.preventDefault(); f[0].focus(); }
      }
      $('[data-spd-skygge]').addEventListener('click', closeKurv);
      $('[data-spd-kurv-luk]').addEventListener('click', closeKurv);

      function announce(cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: root.dataset.section, data: { source: 'supermen-vare', itemCount: cart.item_count } } }));
      }
      function afterAdd() {
        // Ligger varen allerede som gave, følger antallet med i gaveindpakningens felt
        return hentKurv().then(function (cart) {
          return gave ? gaveGem(cart, gaveTitler(cart)).catch(function () { return cart; }) : cart;
        }).then(function (cart) {
          announce(cart);
          if (root.dataset.afterAdd === 'cart') { window.location.href = root.dataset.cartUrl; return; }
          openKurv(cart);
        });
      }
      function addItems(items) {
        return fetch(base(root) + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) {
            if (!r.ok) throw new Error(j.description || j.message || 'Varen kunne ikke lægges i kurven. Prøv igen.');
            return j;
          });
        });
      }
      $('[data-spd-linjer]').addEventListener('click', function (e) {
        var lines = $('[data-spd-linjer]');
        var g = e.target.closest('[data-gave-titel]');
        if (g && sidsteKurv) {
          // Knappen skifter med det samme; valgene gemmes ét ad gangen bagefter
          var titel = g.dataset.gaveTitel, k = gaveSet.indexOf(titel), paa = k < 0;
          if (paa) gaveSet.push(titel); else gaveSet.splice(k, 1);
          all(lines, '[data-gave-titel]').forEach(function (x) { if (x.dataset.gaveTitel === titel) x.setAttribute('aria-pressed', paa ? 'true' : 'false'); });
          g.classList.remove('is-pop');
          if (paa) { void g.offsetWidth; g.classList.add('is-pop'); }
          gaveVenter++;
          gaveKoe = gaveKoe.then(function () { return gaveGem(sidsteKurv, gaveSet.slice()); }).then(function (cart) {
            sidsteKurv = cart;
          }, function () {
            // Kunne ikke gemmes: vis det, der faktisk ligger i kurven
            return hentKurv().then(function (cart) { if (gaveVenter === 1) paint(cart); }).catch(function () {});
          }).then(function () { gaveVenter--; });
          return;
        }
        var b = e.target.closest('[data-line]');
        if (!b) return;
        lines.classList.add('is-busy');
        gaveKoe.then(function () {
          return fetch(base(root) + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: +b.dataset.line, quantity: Math.max(0, +b.dataset.to) })
          });
        }).then(function (r) { return r.json(); }).then(function (cart) {
          if (!cart || !cart.items) return;
          // Antal ændret eller vare fjernet: gaveindpakningens "(x2)" følger med
          return (gave ? gaveGem(cart, gaveTitler(cart)).catch(function () { return cart; }) : Promise.resolve(cart)).then(function (c) { paint(c); announce(c); });
        }).finally(function () { lines.classList.remove('is-busy'); });
      });

      var err = $('[data-spd-error]');
      if (form && atc) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var v = current();
          if (!v || !v.available) {
            var gi = sel.indexOf(null);
            if (gi < 0) gi = sel.indexOf(undefined);
            var g = groups[gi >= 0 ? gi : 0];
            var first = g && !allOut && (isList(g) ? g : g.querySelector('[data-value]:not(.is-udsolgt)') || g.querySelector('[data-value]'));
            if (first && !v) first.focus();
            if (note) {
              note.textContent = allOut ? 'Varen er desværre udsolgt.' : v ? (groups.length > 1 ? 'Udsolgt i den kombination.' : 'Udsolgt i ' + sel[0] + '.') : 'Vælg ' + missing().join(' og ') + ' først.';
              note.classList.add('is-alert');
            }
            return;
          }
          if (atc.classList.contains('is-busy')) return;
          if (err) err.hidden = true;
          atc.classList.add('is-busy');
          addItems([{ id: v.id, quantity: qty() }]).then(function () {
            atc.classList.add('is-done');
            window.setTimeout(function () { atc.classList.remove('is-done'); }, 2200);
            return afterAdd();
          }).catch(function (x) {
            if (err) { err.textContent = x.message; err.hidden = false; }
          }).finally(function () { atc.classList.remove('is-busy'); });
        });
      }

      root._spd = { addItems: addItems, afterAdd: afterAdd, closeKurv: closeKurv, closeLys: closeLys, trap: trap };

      /* Købsbjælke på mobil: vises, når knappen er rullet ud af syne */
      var mbar = $('[data-spd-mbar]');
      var mbtn = $('[data-spd-mbar-btn]');
      if (mbar && (!atc || !form || !('IntersectionObserver' in window))) {
        mbar.remove();
      } else if (mbar) {
        mbtn.addEventListener('click', function () {
          var v = current();
          if (v && v.available) {
            if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
          } else {
            (groups[0] || atc).scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
        new IntersectionObserver(function (es) {
          var e = es[0];
          var on = !e.isIntersecting && e.boundingClientRect.top < 0;
          mbar.classList.toggle('is-on', on);
          mbar.setAttribute('aria-hidden', on ? 'false' : 'true');
          mbtn.tabIndex = on ? 0 : -1;
        }).observe(atc);
      }

      /* Dagens åbningstid, og om butikken har åbent lige nu */
      all(root, '[data-spd-today]').forEach(function (el) {
        var days = (el.dataset.hours || '').split('|');
        var now = new Date();
        var line = (days[(now.getDay() + 6) % 7] || '').trim();
        if (!line) return;
        var m = line.match(/(\d{1,2})[.:](\d{2})\s*[-–]\s*(\d{1,2})[.:](\d{2})/);
        var text, open = false;
        if (!m) {
          text = /\d/.test(line) ? line : 'Lukket i dag';
        } else {
          var mins = now.getHours() * 60 + now.getMinutes();
          var from = +m[1] * 60 + +m[2], to = +m[3] * 60 + +m[4];
          var tTo = m[3] + '.' + m[4], tFrom = m[1] + '.' + m[2];
          if (mins < from) text = 'Åbner kl. ' + tFrom;
          else if (mins < to) { text = 'Åbent nu til ' + tTo; open = true; }
          else text = 'Lukket for i dag';
        }
        el.classList.toggle('is-aaben', open);
        el.innerHTML = '<span class="spd-prik"></span>' + esc(text);
      });
    }

    /* ---------- Supermen om varen: billedet vælges automatisk ---------- */
    function initOm(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var fig = root.querySelector('[data-spd-om-billede]');
      if (!fig) return;
      var cands = (fig.dataset.kandidater || '').split('^').filter(Boolean).map(function (s) {
        var p = s.split('~');
        return { tiny: p[0], src: p[1], srcset: p[2], ratio: +p[3] || 0.8 };
      });
      // Looket i "Supermen flere varer" venter på valget her, så de to ikke viser samme billede
      fig._valg = Promise.all(cands.map(function (c) { return edgeInfo(c.tiny); })).then(function (infos) {
        // Et foto taget uden for studiet (motiv helt ud til kanten) foretrækkes frem for et packshot
        var pick = -1;
        infos.forEach(function (info, i) { if (pick < 0 && info && info.photo) pick = i; });
        var img = fig.querySelector('img');
        if (pick >= 0 && img && cands[pick].src.split('?')[0] !== (img.getAttribute('src') || '').split('?')[0]) {
          img.srcset = cands[pick].srcset;
          img.src = cands[pick].src;
          fig.classList.remove('is-square');
          fig.removeAttribute('data-bg');
          fig.style.backgroundImage = '';
        }
        if (fig.hasAttribute('data-bg')) sampleBg(fig);
        return img ? (img.getAttribute('src') || '').split('?')[0] : '';
      });
    }

    /* ---------- Style den med som look: billede, størrelser, samlet pris, alt i kurven ---------- */
    function lookFoto(el) {
      var alts = (el.dataset.skift || '').split('^').filter(Boolean).map(function (s) {
        var p = s.split('~');
        return { tiny: p[0], src: p[1], srcset: p[2], ratio: +p[3] || 0.8 };
      });
      var img = el.querySelector('img');
      if (!img || !el.dataset.tiny) return;
      var first = { tiny: el.dataset.tiny, src: img.getAttribute('src'), srcset: img.getAttribute('srcset') };
      var cands = [first].concat(alts);
      var om = document.querySelector('[data-spd-om-billede]');
      var omValg = (om && om._valg) || Promise.resolve('');
      Promise.all([omValg].concat(cands.map(function (c) { return edgeInfo(c.tiny); }))).then(function (res) {
        var brugt = res[0] || '', infos = res.slice(1);
        function key(c) { return (c.src || '').split('?')[0]; }
        // Første modelbillede, som "Om varen" ikke allerede viser
        var pick = -1;
        infos.forEach(function (x, i) { if (pick < 0 && x && x.photo && key(cands[i]) !== brugt) pick = i; });
        if (pick <= 0) return;
        var a = cands[pick];
        el.classList.add('is-skifter');
        window.setTimeout(function () {
          img.srcset = a.srcset;
          img.src = a.src;
          el.classList.remove('is-square', 'is-hvid', 'is-kant');
          el.removeAttribute('data-bg');
          el.style.backgroundColor = '';
          el.style.backgroundImage = '';
          ['--spd-lys', '--spd-kant-top', '--spd-kant-bund'].forEach(function (v) { el.style.removeProperty(v); });
          var vis = function () { el.classList.remove('is-skifter'); };
          if (img.complete) vis(); else { img.addEventListener('load', vis, { once: true }); img.addEventListener('error', vis, { once: true }); }
        }, 200);
      });
    }
    function initLook(root, sec) {
      if (sec._look) { sec._look(); return; }
      var knap = sec.querySelector('[data-spd-look-knap]');
      var knapTekst = sec.querySelector('[data-spd-look-knap-tekst]');
      var sum = sec.querySelector('[data-spd-look-sum]');
      var status = sec.querySelector('[data-spd-status]');
      function rows() { return all(sec, '[data-spd-look-vare]'); }
      function valgt(li) {
        var v = li.querySelector('[data-spd-look-v]');
        if (!v) return null;
        if (v.tagName === 'SELECT') return v.value ? v.options[v.selectedIndex] : null;
        return v;
      }
      function upd() {
        var total = 0, n = 0;
        rows().forEach(function (li, i) {
          var med = li.querySelector('[data-spd-look-med]');
          var nr = med && med.nextElementSibling;
          if (nr) nr.textContent = i + 1;
          var paa = !med || med.checked;
          li.classList.toggle('is-fra', !paa);
          var pr = li.querySelector('[data-spd-look-pris]');
          var o = valgt(li);
          var pris = +((o && o.dataset.pris) || (pr && pr.dataset.pris) || 0);
          var foer = +((o && o.dataset.foer) || (pr && pr.dataset.foer) || 0);
          if (pr && o) pr.innerHTML = (foer > pris ? '<s>' + money(foer) + '</s> ' : '') + '<span>' + money(pris) + '</span>';
          if (paa) { total += pris; n++; }
        });
        if (sum) sum.textContent = money(total);
        var antal = rows().length;
        if (knapTekst) knapTekst.textContent = n === antal ? knap.dataset.alle : 'Læg ' + n + (n === 1 ? ' vare' : ' varer') + ' i kurven';
        if (knap) knap.disabled = n === 0;
      }
      sec._look = upd;
      sec.addEventListener('change', function (e) {
        var li = e.target.closest('[data-spd-look-vare]');
        if (li && e.target.matches('[data-spd-look-v]')) li.classList.remove('is-mangler');
        if (li && e.target.matches('[data-spd-look-med]') && !e.target.checked) li.classList.remove('is-mangler');
        if (status) status.textContent = '';
        upd();
      });
      if (knap) knap.addEventListener('click', function () {
        if (knap.classList.contains('is-busy')) return;
        var med = rows().filter(function (li) { var c = li.querySelector('[data-spd-look-med]'); return !c || c.checked; });
        var mangler = med.filter(function (li) { return !valgt(li); });
        rows().forEach(function (li) { li.classList.toggle('is-mangler', mangler.indexOf(li) > -1); });
        if (mangler.length) {
          var navne = mangler.map(function (li) { var a = li.querySelector('.spd-look__navn'); return a ? a.textContent.trim() : ''; });
          if (status) status.textContent = 'Vælg størrelse på ' + navne.join(' og ') + '.';
          var s = mangler[0].querySelector('select');
          if (s) s.focus();
          return;
        }
        var items = med.map(function (li) { return { id: +valgt(li).value, quantity: 1 }; });
        knap.classList.add('is-busy');
        leggI(root, items, status, function () {
          knap.classList.remove('is-busy');
          if (status && main()) status.textContent = '';
        }, function (msg) {
          knap.classList.remove('is-busy');
          if (status) status.textContent = msg;
        });
      });
      var foto = sec.querySelector('[data-spd-look-foto]');
      if (foto) lookFoto(foto);
      upd();
    }

    /* ---------- Supermen flere varer: rækker, dubletter, anbefalinger, hurtig-tilføj ---------- */
    function bindRow(sec) {
      var track = sec.querySelector('[data-spd-track]');
      if (!track) return;
      if (sec._upd) { sec._upd(); return; }
      var btns = all(sec, '[data-spd-dir]');
      var maaler = sec.querySelector('[data-spd-maaler]'), tommel = maaler && maaler.firstElementChild;
      function upd() {
        var max = track.scrollWidth - track.clientWidth - 2;
        btns.forEach(function (b) {
          b.hidden = max <= 0;
          b.disabled = +b.dataset.spdDir < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max;
        });
        if (!maaler) return;
        maaler.classList.toggle('is-tom', max <= 0);
        if (max <= 0) return;
        var s = track.clientWidth / track.scrollWidth;
        var x = Math.max(0, Math.min(track.scrollLeft, max + 2)) / (max + 2);
        tommel.style.setProperty('--spd-ms', s.toFixed(4));
        tommel.style.setProperty('--spd-mx', (x * (1 - s) * 100).toFixed(2) + '%');
      }
      sec._upd = upd;
      btns.forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: +b.dataset.spdDir * track.clientWidth * 0.9 }); });
      });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(upd).observe(track);
      upd();
    }
    function quickAdd(root, btn) {
      if (btn.classList.contains('is-busy')) return;
      var sec = btn.closest('[data-spd-raekke]');
      var status = sec && sec.querySelector('[data-spd-status]');
      var items = [{ id: +btn.dataset.spdAdd, quantity: 1 }];
      btn.classList.add('is-busy');
      function ok() {
        btn.classList.remove('is-busy');
        btn.classList.add('is-ok');
        if (status) status.textContent = '';
        window.setTimeout(function () { btn.classList.remove('is-ok'); }, 2400);
      }
      function fail(msg) {
        btn.classList.remove('is-busy');
        if (status) status.textContent = msg;
      }
      leggI(root, items, status, ok, fail);
    }
    // Lægger varer i kurven: via "Supermen vare" (kurven glider ind), ellers direkte med en besked
    function leggI(root, items, status, ok, fail) {
      if (main()) {
        document.dispatchEvent(new CustomEvent('supermen:add', { detail: { items: items, onSuccess: ok, onError: fail } }));
        return;
      }
      fetch(base(root) + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.description || 'Varen kunne ikke lægges i kurven. Prøv igen.'); });
      }).then(function () {
        return fetch(base(root) + 'cart.js').then(function (r) { return r.json(); });
      }).then(function (cart) {
        ok();
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'supermen-flere-varer', data: { source: 'supermen-flere-varer', itemCount: cart.item_count } } }));
        if (status) status.innerHTML = 'Lagt i kurven. <a href="' + esc(root.dataset.cartUrl) + '">Gå til kurven</a>';
      }).catch(function (e) { fail(e.message); });
    }
    function initMere(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      all(root, '[data-bg]').forEach(sampleBg);
      all(root, '.spd-raekke--farver').forEach(function (r) { ensart(all(r, '.spd-flise__im')); });
      root.addEventListener('click', function (e) {
        var b = e.target.closest('[data-spd-add]');
        if (b && !b.disabled) quickAdd(root, b);
      });
      var rows = all(root, '[data-spd-raekke]');
      // En vare vises kun én gang på tværs af rækkerne (og andre farver af varen vises ikke)
      // Rækker, der hentes bagefter, tjekker alle andre rækker; de øvrige kun rækkerne over sig
      function seenBefore(sec, everyOther) {
        var seen = ',';
        rows.forEach(function (r) { seen += (r.dataset.exclude || ',').slice(1); });
        for (var i = 0; i < rows.length; i++) {
          if (rows[i] === sec) { if (everyOther) continue; break; }
          if (rows[i].hidden) continue;
          all(rows[i], '[data-pid]').forEach(function (c) { seen += c.dataset.pid + ','; });
        }
        return seen;
      }
      function settle(sec, cards, everyOther) {
        var limit = +sec.dataset.limit || 8;
        var seen = seenBefore(sec, everyOther);
        var keep = cards.filter(function (c) {
          if (seen.indexOf(',' + c.dataset.pid + ',') > -1) return false;
          if (sec.dataset.type && (c.dataset.type || '').toLowerCase() !== sec.dataset.type.toLowerCase()) return false;
          seen += c.dataset.pid + ',';
          return true;
        }).slice(0, limit);
        return keep;
      }
      rows.forEach(function (sec) {
        if (sec.dataset.intent) return;
        if (sec.hasAttribute('data-spd-look')) {
          if (!sec.querySelector('[data-spd-look-vare]:not([data-self])')) { sec.hidden = true; return; }
          initLook(root, sec);
          return;
        }
        var track = sec.querySelector('[data-spd-track]');
        var cards = all(track, '[data-pid]');
        if (!cards.length) { bindRow(sec); return; }
        var keep = settle(sec, cards);
        cards.forEach(function (c) { if (keep.indexOf(c) < 0) c.remove(); });
        if (keep.length < 2) { sec.hidden = true; return; }
        bindRow(sec);
      });
      var url = root.dataset.recUrl;
      if (!url) return;
      rows.forEach(function (sec) {
        if (!sec.dataset.intent) return;
        fetch(url + '&intent=' + sec.dataset.intent + '&limit=10')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            if (sec.hasAttribute('data-spd-look')) {
              var nye = all(doc, '[data-block-id="' + sec.dataset.blockId + '"] [data-spd-look-vare]');
              var tag = settle(sec, nye, true);
              if (!tag.length) return;
              var liste = sec.querySelector('[data-spd-look-liste]');
              all(liste, '[data-spd-look-vare]:not([data-self])').forEach(function (li) { li.remove(); });
              tag.forEach(function (li) { liste.appendChild(document.importNode(li, true)); });
              all(liste, '[data-bg]').forEach(sampleBg);
              sec.hidden = false;
              initLook(root, sec);
              return;
            }
            var got = doc.querySelector('[data-block-id="' + sec.dataset.blockId + '"] [data-spd-track]');
            if (!got) return;
            var keep = settle(sec, Array.prototype.slice.call(got.children).filter(function (c) { return c.dataset.pid; }), true);
            if (keep.length < 2) return;
            var track = sec.querySelector('[data-spd-track]');
            track.innerHTML = '';
            keep.forEach(function (c) { track.appendChild(document.importNode(c, true)); });
            all(track, '[data-bg]').forEach(sampleBg);
            sec.hidden = false;
            bindRow(sec);
          })
          .catch(function () {});
      });
    }

    function boot() {
      all(document, '[data-spd-vare]').forEach(initVare);
      all(document, '[data-spd-om]').forEach(initOm);
      all(document, '[data-spd-mere]').forEach(initMere);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
